import { useEffect } from "react";
import { useAppDispatch } from "../../../../redux/useDispatch";
import { setUseCase } from "../../../../redux/slice/bookingCreation/bookingCreationSlice";
import { useQueryParamGuard } from "./useQueryParamGuard";

/**
 * Common initialization logic for all Key Handover pages.
 * 
 * @remarks
 * Handles:
 * - Setting use case to "keys"
 * - Validating required query parameters (locationId, serviceId)
 * - Redirecting to appropriate step if params are missing
 * 
 * @example
 * ```tsx
 * function MyPage() {
 *   useKeyHandoverPageInit();
 *   // Page is now initialized
 *   return <Content />;
 * }
 * ```
 */
export function useKeyHandoverPageInit(): void {
  const dispatch = useAppDispatch();

  // Set use case once on mount
  useEffect(() => {
    dispatch(setUseCase({ useCase: "keys" }));
  }, [dispatch]);

  // Guard required query parameters
  useQueryParamGuard();
}
